module.exports = __webpack_public_path__ + "img/home_service.30e346fb.png";